import { createRoute } from '@tanstack/react-router'
import { Route as cmsLayoutRoute } from './layout'

export const Route = createRoute({
  getParentRoute: () => cmsLayoutRoute,
  path: '/cms/content',
}).lazy(() => import('./content.lazy').then((d) => d.Route))
